<template>
  <section>
    <div class="title" v-if="role === 'self'">我的粉丝({{totalRows}})</div>
    <div class="title" v-else>他的粉丝({{totalRows}})</div>
    <div class="articleList">
      <div class="item" v-for="focus in dataLst" :key="focus.followerId">
        <img :src="focus.fromUser.headImg || defaultHead"/>
        <div class="name">{{focus.fromUser.userName}}</div>
        <div class="btn" @click="addFocus(focus)" v-if="focus.eachFocus >= 0 && focus.eachFocus%2 === 1">已关注</div>
        <div class="btnNo" @click="addFocus(focus)" v-if="focus.eachFocus >= 0 && focus.eachFocus%2 === 0">+&nbsp;关注</div>
      </div>
      <div class="noData" v-show="!dataLst || dataLst.length ===0">暂时没有关注~</div>
    </div>
    <laypage :pages="totalPages" @jump="updateDataPage" v-show="dataLst && totalRows > pageSize"
             :groups="totalPages>8?8:totalPages" skip="skip" class="layPage"></laypage>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </section>
</template>

<script>
import loading from '../common/loading.vue'
export default {
  props: {
    role: {
      type: String,
      default: 'self'
    },
    userId: {
      type: String,
      default: ''
    }
  },
  name: 'userHome',
  data () {
    return {
      msg: '关注列表',
      defaultHead: require('../../assets/image/installer.png'),
      page: 1,
      pageSize: 6,
      totalPages: 10,
      totalRows: 0,
      dataLst: [],
      isLoad: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.getDataLst()
  },
  methods: {
    addFocus: function (focus) {
      let that = this
      that.isLoad = true
      that.axios.post('/user/follow', {
        fromId: that.$root.getUserId(),
        toId: focus.fromId,
        flag: (focus.eachFocus % 2 === 0)
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          focus.eachFocus += 1
          that.getDataLst()
          that.$emit('updateUser')
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    'updateDataPage': function (p) {
      this.page = p
      this.getDataLst()
    },
    'getDataLst': function () {
      let toId = this.$root.getUserId()
      if (this.role === 'other') {
        toId = this.userId
      }
      this.isLoad = true
      let that = this
      that.axios.post('user/followList', {
        toId: toId,
        userId: that.$root.getUserId(),
        page: that.page,
        pageSize: that.pageSize
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          that.dataLst = res.dataLst
          that.totalPages = res.totalPages
          that.totalRows = res.totalRows
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {},
  components: {
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  padding-left: 30px;
  background-color: #FFFFFF;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
}
.articleList {
  width: 980px;
}
.articleList .item {
  width: 950px;
  height: 112px;
  line-height: 112px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F0F0F0;
}
.articleList .item img {
  padding: 32px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  float: left;
}
.articleList .item .name {
  float: left;
}
.articleList .item .btn, .articleList .item .btnNo {
  float: right;
  margin-right: 20px;
  margin-top: 41px;
  width: 100px;
  text-align: center;
  line-height: 30px;
  color: #0AB878;
  border: 1px solid #0AB878;
  cursor: pointer;
}
.articleList .item .btnNo {
  color: #FFFFFF;
  background-color: #0AB878;
}
.articleList .noData {
  width: 950px;
  margin-top: 20px;
  background-color: #FFFFFF;
  text-align: center;
  line-height: 100px;
  color: #A0A0A0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userFollower.vue